import { render } from "./App.vue?vue&type=template&id=c1cb2c90"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=c1cb2c90&lang=scss"

import exportComponent from "/Users/smzdm/Desktop/前端项目/畅效官网/cx_official_website/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__